var React = require('react');

function ArrowCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","transform":"matrix(1 0 0 -1 0 24)","fill":"#FFD552","key":0}),React.createElement("path",{"d":"M15.6566 11.8728L5.00415 11.8728","stroke":"black","strokeWidth":"2.11209","key":1}),React.createElement("path",{"d":"M18.0565 11.9802C16.0063 11.9521 11.9219 10.2753 11.953 7.14207","stroke":"black","strokeWidth":"2.11209","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M18.0692 11.9791C16.019 11.951 11.9025 13.5154 11.8715 16.6486","stroke":"black","strokeWidth":"2.11209","strokeLinejoin":"round","key":3})]);
}

ArrowCircleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":""};

module.exports = ArrowCircleInline;

ArrowCircleInline.default = ArrowCircleInline;
